import React from 'react'
import Table from './Components/Table'
import AddRent from './Components/AddRentPage'
import EditRent from './Components/EditRentPage'
import NavBar from './Components/NavBar'
import Home from './Components/HomePage'
import { BrowserRouter, Route, Routes } from 'react-router-dom'


function App() {
  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/all' element={<Table />} />
        <Route path='/add' element={<AddRent />} />
        <Route path='/edit/:id' element={<EditRent />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
